import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from '../../services/theme.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  navItems = [
    { label: 'Fuel Entry', icon: 'pi pi-car', route: '/fuel' },
    { label: 'Fuel Entries', icon: 'pi pi-list', route: '/entries' },
    { label: 'Upload', icon: 'pi pi-upload', route: '/upload' },
    { label: 'Admin', icon: 'pi pi-cog', route: '/admin' },
  ];

  isDarkTheme = false;

  constructor(
    private router: Router,
    private themeService: ThemeService,
    private authService: AuthService
  ) {}

  navigate(route: string): void {
    this.router.navigate([route]);
  }

  isActive(route: string): boolean {
    return this.router.url === route;
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
    this.isDarkTheme = this.themeService.getCurrentTheme() === 'viva-dark';
  }

  signOut(): void {
    this.authService.logout();
  }
}
